module.exports = __webpack_public_path__ + "static/Fantastic_Beasts_1920x900.26d5bace.png";